export const rakuten = {
  name: 'Rakuten TV',
  id: 'rakuten',
  url: 'https://rakuten.tv/',
  color: '#af2c24',
  compatible: false
}
